
const saveDraft = (orderData) => {
    return {
        type: 'UPDATE',
        orderData
    }
}

const clearDraft = () => {
    return {
        type: 'CLEAR'
    }
}



const draftReducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE':
            return action.orderData;
        case 'CLEAR':
            return null;
        default:
            return state;
    }
}

export { saveDraft, clearDraft, draftReducer as default }